function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import EventEmitter from './event-emitter.js';

var Player = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Player, _EventEmitter);

  var _super = _createSuper(Player);

  function Player(options) {
    var _this;

    _classCallCheck(this, Player);

    _this = _super.call(this);
    _this.isExternalMedia = false;

    if (options.media) {
      _this.media = options.media;
      _this.isExternalMedia = true;
    } else {
      _this.media = document.createElement('audio');
    } // Controls


    if (options.mediaControls) {
      _this.media.controls = true;
    } // Autoplay


    if (options.autoplay) {
      _this.media.autoplay = true;
    } // Speed


    if (options.playbackRate != null) {
      _this.onceMediaEvent('canplay', function () {
        if (options.playbackRate != null) {
          _this.media.playbackRate = options.playbackRate;
        }
      });
    }

    return _this;
  }

  _createClass(Player, [{
    key: "onMediaEvent",
    value: function onMediaEvent(event, callback, options) {
      var _this2 = this;

      this.media.addEventListener(event, callback, options);
      return function () {
        return _this2.media.removeEventListener(event, callback);
      };
    }
  }, {
    key: "onceMediaEvent",
    value: function onceMediaEvent(event, callback) {
      return this.onMediaEvent(event, callback, {
        once: true
      });
    }
  }, {
    key: "getSrc",
    value: function getSrc() {
      return this.media.currentSrc || this.media.src || '';
    }
  }, {
    key: "revokeSrc",
    value: function revokeSrc() {
      var src = this.getSrc();

      if (src.startsWith('blob:')) {
        URL.revokeObjectURL(src);
      }
    }
  }, {
    key: "canPlayType",
    value: function canPlayType(type) {
      return this.media.canPlayType(type) !== '';
    }
  }, {
    key: "setSrc",
    value: function setSrc(url, blob) {
      var src = this.getSrc();
      if (src === url) return;
      this.revokeSrc();
      var newSrc = blob instanceof Blob && this.canPlayType(blob.type) ? URL.createObjectURL(blob) : url;
      this.media.src = newSrc;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.media.pause();
      if (this.isExternalMedia) return;
      this.media.remove();
      this.revokeSrc();
      this.media.src = ''; // Load resets the media element to its initial state

      this.media.load();
    }
  }, {
    key: "setMediaElement",
    value: function setMediaElement(element) {
      this.media = element;
    }
    /** Start playing the audio */

  }, {
    key: "play",
    value: function play() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.media.src) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                return _context.abrupt("return", this.media.play());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /** Pause the audio */

  }, {
    key: "pause",
    value: function pause() {
      this.media.pause();
    }
    /** Check if the audio is playing */

  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return !this.media.paused && !this.media.ended;
    }
    /** Jump to a specific time in the audio (in seconds) */

  }, {
    key: "setTime",
    value: function setTime(time) {
      this.media.currentTime = time;
    }
    /** Get the duration of the audio in seconds */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.media.duration;
    }
    /** Get the current audio position in seconds */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.media.currentTime;
    }
    /** Get the audio volume */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.media.volume;
    }
    /** Set the audio volume */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.media.volume = volume;
    }
    /** Get the audio muted state */

  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.media.muted;
    }
    /** Mute or unmute the audio */

  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      this.media.muted = muted;
    }
    /** Get the playback speed */

  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.media.playbackRate;
    }
    /** Check if the audio is seeking */

  }, {
    key: "isSeeking",
    value: function isSeeking() {
      return this.media.seeking;
    }
    /** Set the playback speed, pass an optional false to NOT preserve the pitch */

  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate, preservePitch) {
      // preservePitch is true by default in most browsers
      if (preservePitch != null) {
        this.media.preservesPitch = preservePitch;
      }

      this.media.playbackRate = rate;
    }
    /** Get the HTML media element */

  }, {
    key: "getMediaElement",
    value: function getMediaElement() {
      return this.media;
    }
    /** Set a sink id to change the audio output device */

  }, {
    key: "setSinkId",
    value: function setSinkId(sinkId) {
      // See https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId
      var media = this.media;
      return media.setSinkId(sinkId);
    }
  }]);

  return Player;
}(EventEmitter);

export default Player;